import { Auth } from '@aws-amplify/auth'
import store from '../store'

/**
 * Logout from Cognito
 *
 * @param {boolean} reload
 * @param {boolean} fromSfn
 * @return {Promise<unknown>|null}
 */
const cognitoLogout = (reload = true, fromSfn = false) => {
    const state = store.getState().auth

    if (!Auth) {
        return window.swalert('Funkce autorizace není momentálně dostupná')
    }

    return Auth.signOut().then(() => {
        localStorage.removeItem('cognito.tokens')
        localStorage.removeItem('cognito.user.attributes')

        if (state.logoutRedirectPage) {
            store.dispatch({
                type: 'SET_LOGOUT_REDIRECT',
                page: null,
            })
            window.location.href = state.logoutRedirectPage
            return new Promise(resolve => resolve())
        }

        if (fromSfn) {
            window.location.href = '/sfn'
        }

        if (reload && !fromSfn) {
            window.location.reload()
        }
    })
}

/**
 * Unlog logged user
 *
 * @param {boolean} reload
 * @param {boolean} fromSfn
 * @return {Promise}
 */
export default (reload = true, fromSfn = false) => {
    store.dispatch({ type: 'TOGGLE_FETCHING_LOGOUT' })

    return window.axios.delete(`${window.APP_CONFIG.REACT_APP_API_URL}api/logout`)
        .then(() => {
            localStorage.removeItem('sportnect.tokens')
            window.axios.defaults.headers.common.Authorization = null

            store.dispatch({ type: 'LOGOUT' })

            return cognitoLogout(reload, fromSfn)
        })
}
